module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Tryout")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Tryout\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "id": "tryout_tambah",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createTryout()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tryout\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reportTryout()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chart-bell-curve")]), _vm._v("\n                Lihat Laporan\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.ratingTryout()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-star")]), _vm._v("\n                Rating dan Feedback\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.tryouts,
      "headers": _vm.headers,
      "has-action": false,
      "has-export": true,
      "has-duplicate": true,
      "hasReview": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editTryout()
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "duplicateClicked": function($event) {
        return _vm.duplicateTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: $event.key.value
        }
      },
      "openNewTab": function($event) {
        return _vm.openNewTab($event)
      },
      "openReview": function($event) {
        return _vm.openReview($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "536px",
      "persistent": "",
      "height": "168px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogConfirm.title = 'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm.open = true;
        _vm.dialogConfirm.function = 'onDuplicateCancel';
      }
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("\n                Detail Duplikat Tryout\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm.open = true;
        _vm.dialogConfirm.function = 'onDuplicateCancel';
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-4 px-6"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Judul\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Tryout",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.name),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "name", $$v)
      },
      expression: "tryout.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Deskripsi\n                        ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi Tryout",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.description),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "description", $$v)
      },
      expression: "tryout.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Jenjang\n                        ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank')
    },
    model: {
      value: (_vm.tryout.level),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "level", $$v)
      },
      expression: "tryout.level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Umum",
      "value": "UMUM",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Tipe\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Tipe",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'SBMPTN',
          value: 'SBMPTN'
        },
        {
          text: 'Ujian Nasional (UN)',
          value: 'UJIAN_AKHIR_NASIONAL',
        },
        {
          text: 'Ujian Akhir Sekolah (UAS)',
          value: 'UJIAN_AKHIR_SEKOLAH',
        },
        {
          text: 'Ujian Sekolah',
          value: 'UJIAN_SEKOLAH',
        } ]
    },
    model: {
      value: (_vm.tryout.tipe),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "tipe", $$v)
      },
      expression: "tryout.tipe"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tryout.tipe == 'SBMPTN') ? _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Kategori\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'TPS',
          value: 'TPS'
        },
        {
          text: 'SAINTEK',
          value: 'SAINTEK'
        },
        {
          text: 'SOSHUM',
          value: 'SOSHUM',
        },
        {
          text: 'LITERASI',
          value: 'LITERASI',
        } ]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1) : (_vm.tryout.tipe == 'UJIAN_AKHIR_NASIONAL') ? _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Kategori\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'SAINTEK',
          value: 'SAINTEK'
        },
        {
          text: 'SOSHUM',
          value: 'SOSHUM',
        } ]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1) : _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Kategori\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
        text: 'OTHER',
        value: 'OTHER'
      }]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Durasi (Menit)\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "type": "number",
      "placeholder": "(menit)",
      "suffix": "menit",
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.durasi),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "durasi", $$v)
      },
      expression: "tryout.durasi"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Jenis\n                        ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "label": "Instant",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.is_repeated),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "is_repeated", $$v)
      },
      expression: "tryout.is_repeated"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Waktu Mulai\n                        ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.start_date.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.start_date, "value", $$v)
            },
            expression: "\n                                                    tryout.start_date.value\n                                                "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.start_date.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_date, "option", $$v)
      },
      expression: "tryout.start_date.option"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.tryout.start_date.option = false
      }
    },
    model: {
      value: (
        _vm.tryout.start_date.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_date, "value", $$v)
      },
      expression: "\n                                                tryout.start_date.value\n                                            "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline",
            "readonly": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.start_time.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.start_time, "value", $$v)
            },
            expression: "\n                                                    tryout.start_time.value\n                                                "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.start_time.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_time, "option", $$v)
      },
      expression: "tryout.start_time.option"
    }
  }, [_vm._v(" "), (_vm.tryout.start_time.option) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "input": function($event) {
        _vm.tryout.start_time.value =
          _vm.tryout.start_time.value ?
          _vm.tryout.start_time
          .value + ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu1.save(
          _vm.tryout.start_time.value
        )
      }
    },
    model: {
      value: (
        _vm.tryout.start_time.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_time, "value", $$v)
      },
      expression: "\n                                                tryout.start_time.value\n                                            "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Waktu Berakhir\n                        ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.end_date.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.end_date, "value", $$v)
            },
            expression: "\n                                                    tryout.end_date.value\n                                                "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.end_date.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_date, "option", $$v)
      },
      expression: "tryout.end_date.option"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.tryout.end_date.option = false
      }
    },
    model: {
      value: (_vm.tryout.end_date.value),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_date, "value", $$v)
      },
      expression: "tryout.end_date.value"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline",
            "readonly": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.end_time.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.end_time, "value", $$v)
            },
            expression: "\n                                                    tryout.end_time.value\n                                                "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.end_time.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_time, "option", $$v)
      },
      expression: "tryout.end_time.option"
    }
  }, [_vm._v(" "), (_vm.tryout.end_time.option) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "input": function($event) {
        _vm.tryout.end_time.value =
          _vm.tryout.end_time.value ?
          _vm.tryout.end_time
          .value + ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu.save(
          _vm.tryout.end_time.value
        )
      }
    },
    model: {
      value: (_vm.tryout.end_time.value),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_time, "value", $$v)
      },
      expression: "tryout.end_time.value"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm.open = true;
        _vm.dialogConfirm.function = 'onDuplicateCancel';
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.title =
          'Yakin ingin melakukan duplikasi pada Tryout ini ?';
        _vm.dialogConfirm.open = true;
        _vm.dialogConfirm.function = 'onDuplicateConfirm';
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), (_vm.dialogConfirm.function == 'onDuplicateConfirm') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateConfirm
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e(), _vm._v(" "), (_vm.dialogConfirm.function == 'onDuplicateCancel') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateCancel
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.dialogReview) ? _c('preview-soal', {
    attrs: {
      "data": _vm.data_preview,
      "dialog-review": _vm.dialogReview
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialogReview()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6334393c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/Tryout.vue
// module id = 2081
// module chunks = 1